import { Autocomplete, Box, CircularProgress, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import { useState } from 'react';
import {
  DbLocation,
  useLazyGetApiLocationsQuery,
} from '../../app/athenaApiGen';

type TLocationFilterProps = {
  handleChange: (id?: string | null) => void;
  locationId?: string;
  required?: boolean;
};

const LocationFilter = (props: TLocationFilterProps) => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<DbLocation[]>([]);
  const [queryLocations, { isLoading }] = useLazyGetApiLocationsQuery();

  const handleOpen = async () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    (async () => {
      try {
        const locations = await queryLocations().unwrap();
        setOptions(locations);
      } catch (err) {
        console.log(err);
      }
    })();
  }, [queryLocations]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      <Autocomplete
        open={open}
        onOpen={handleOpen}
        onClose={handleClose}
        isOptionEqualToValue={(option, value) => option.name === value.name}
        getOptionLabel={(option) => option.name ?? ''}
        options={options}
        loading={isLoading}
        value={
          options.find((opt) => opt.locationId === props.locationId) || null
        }
        onChange={(_, newValue) => {
          props.handleChange(newValue ? newValue?.locationId : null);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            required={props.required}
            label="Location"
            size="small"
            slotProps={{
              input: {
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {isLoading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              },
            }}
          />
        )}
      />
    </Box>
  );
};

export default LocationFilter;
